module.exports = __webpack_public_path__ + "img/new_no_coupon.c4aa38b3.png";